module.exports = __webpack_public_path__ + "img/traffic-cone.11c6ec16.svg";